import leMat from "@/assets/images/cards/00_le_mat.jpg";
import leBateleur from "@/assets/images/cards/01_le_bateleur.jpg";
import laPapesse from "@/assets/images/cards/02_la_papesse.jpg";
import limperatrise from "@/assets/images/cards/03_limperatrise.jpg";
import lempereur from "@/assets/images/cards/04_lempereur.jpg";
import lePape from "@/assets/images/cards/05_le_pape.jpg";
import lamoureux from "@/assets/images/cards/06_lamoureux.jpg";
import leCharior from "@/assets/images/cards/07_le_charior.jpg";
import justice from "@/assets/images/cards/08_justice.jpg";
import lermite from "@/assets/images/cards/09_lermite.jpg";
import laRoueDeFortune from "@/assets/images/cards/10_la_roue_de_fortune.jpg";
import laForce from "@/assets/images/cards/11_la_force.jpg";
import lePendu from "@/assets/images/cards/12_le_pendu.jpg";
import thirteen from "@/assets/images/cards/13.jpg";
import tenperance from "@/assets/images/cards/14_tenperance.jpg";
import leDiable from "@/assets/images/cards/15_le_diable.jpg";
import laMaisonDieu from "@/assets/images/cards/16_la_maison_dieu.jpg";
import lestoille from "@/assets/images/cards/17_lestoille.jpg";
import laLune from "@/assets/images/cards/18_la_lune.jpg";
import leSoleil from "@/assets/images/cards/19_le_soleil.jpg";
import leJugement from "@/assets/images/cards/20_le_jugement.jpg";
import leMonde from "@/assets/images/cards/21_le_monde.jpg";
import CardData from "../components/cards/CardData";

const cardList: CardData[] = [
  {
    id: 0,
    number: null,
    name: "Le Mat",
    description: [
      "Este joven busca emprenderse en un viaje. Es un comienzo, sin cargas, por puras ganas e impulso. Lleva consigo solo lo necesario. Viaja liviano y alegre (sus cascabeles). Hay otro personaje presente también: El perro ¿Lo impulsa o lo retiene?",
      "Esta carta nos impulsa a la acción, a animarnos, sin tanta vuelta. En su lado contrario, puede significar que no estemos prestando atención a nuestro alrededor, o que no tengamos en cuenta el afuera."
    ],
    image: leMat,
  },
  {
    id: 1,
    number: "I",
    name: "Le Bateleur",
    description: [
      "Este aprendiz aparenta estar jugando y probando elementos en su mesa. Hay mucho movimiento pero esta vez es mas de la cabeza, está activando su mente. Esos objetos representan las 4 energias (materia, pulsividad, mente y emoción): por lo tanto, posee el todo en sus manos. Lo que haga con eso, lo puede llevar a donde quiera, solo depende de él.",
      "Eso es en parte el mensaje, jugar, comienzo mental, potencialidad. Pero si ven, también mira al costado, como buscando la aprobación. Esa es una buena observación para hacerse a une misme."
    ],
    image: leBateleur,
  },
  {
    id: 2,
    number: "II",
    name: "La Papesse",
    description: [
      "Se detiene y observa. Está tan tapada que no se sabe qué esconde, pero algo está tramando. Mujer sabia y gestante. Algo va a parir. No necesariamente sea un individuo. Puede ser también un proyecto, una idea.",
      "Es momento de frenarse, de ir hacia dentro.Prepararse para lo que viene. Como una planta que acumula energía para dar a lucir sus hojas. Puede ser una madre o una abuela, que abriga y espera con comida casera."
    ],
    image: laPapesse,
  },
  {
    id: 3,
    number: "III",
    name: "L'Impératrise",
    description: [
      "El famoso KE MUJER! Ella en su trono, cómoda, escudada, activa y mandona. Mujer que puede todo, y hace y deshace a su manera. Madre todopoderosa. Trabaja, materia, proyecta y domina todo a la perfección. Sumamente creativa. Simbólicamente su cetro esta apoyado en su bajo vientre, de donde nace su lado mas creativo.",
      "Aquí ya es momento de dar a conocer eso que proyectamos. De conectarnos con nuestra creatividad. De sabernos poderosos.",
      "Puede que también nos estemos aprovechando de algo, como escalar algo."
    ],
    image: limperatrise,
  },
  {
    id: 4,
    number: "IIII",
    name: "L'Empereur",
    description: [
      "Qué cosas se relacionan con el número 4?… El cuadrado, la casa, la familia tipo. El emperador es todo lo que nos da estabilidad. La comodidad, la seguridad.",
      "Representado por un hombre parado, apoyado con el cetro en su mano y el escudo a sus pies, da la sensación de estar descansando y, a la vez, listo para actuar.",
      "Quizás sea momento de ordenar tus cosas, buscar la estabilidad, de ir a lo seguro. O, por el contrario, estar muy estancado o cómodo, y este es un llamado a ir mas allá de lo conocido."
    ],
    image: lempereur,
  },
  {
    id: 5,
    number: "V",
    name: "Le Pape",
    description: [
      "Ya pasamos por las figuras de la corte, los juglares, etc: ahora es momento de ir mas allá, un paso mas, la quinta pata al gato dicen.Sí, es ser rebuscado, porque esta carta trae algo mas allá de lo concreto, trae lo divino, la fé.Pareciese que este personaje da una bendición.",
      "Entonces es momento de salir de la zona de confort. De apostar a algo mas.",
      "Es muy probable que esta carta se relacione a abusos, a engaños o cosas ocultas. Ya que en la parte inferior, pareciesen feligreses de espaldas. Mucho mas pequeños en relación a la figura religiosa, como marcando poder y autoridad por encima de ellos."
    ],
    image: lePape,
  },
  {
    id: 6,
    number: "VI",
    name: "L'Amoureux",
    description: [
      "Primer carta que involucra mas de un personaje. La fascinación del encuentro con otra persona. Y eso hace que traiga confusión.",
      "La persona del medio está, con su cuerpo hacia el personaje de la derecha y con su cabeza al de la izquierda. Da indicio que no sabe qué dirección tomar. Si hacerle caso a su cabeza o a su instinto. Es por eso que aparece cupido. Para flecharlo y que se vuelva a “enamorar” de si mismo y aliñe su cabeza de su corazón.",
    ],
    image: lamoureux,
  },
  {
    id: 7,
    number: "VII",
    name: "Le Charriot",
    description:
      [
        "Pongan el carro en movimiento, que los melones, se acomodan solos. Esta frase es en parte la esencia de la carta. Qué debería activar? Me estoy moviendo?",
        "Aqui vemos a un muchacho, en un carro con dos caballos. Pero es un carro adosado; con cortinados y adornos. Él posee una corona y en su armadura, estan las dos caretas del teatro. Identificamos entonces al teatro relacionado con lo bello, lo estético y lo creativo. Así tb puede estar relacionado con no mostrarse tal cual uno es.",
      ],
    image: leCharior,
  },
  {
    id: 8,
    number: "VIII",
    name: "La Justice",
    description: [
      "Mujer sentada en un trono, posee en una mano una espada, y en la otra, una balanza que no llega a estar equilibrada.",
      "Claro, podría ser una madre mas seria y exigente. Pero esta carta es la primera que nos mira de frente, como si fuésemos espejo, como si nos hablara directo. Esta carta nos esta diciendo justo eso: “hace cargo”, “el momento es ahora”, “no te exijas tanto, no todo es perfecto”. Es una madre que pone limites, pero también lo hace desde el amor.",
    ],
    image: justice,
  },
  {
    id: 9,
    number: "VIIII",
    name: "L'Ermite",
    description: [
      "Me gusta llamarlo “El manguero del tarot”: y sí, sabe que algo se está por terminar, y como es tan sabio, hace un recorrido recordando los buenos momentos (y tb los malos). Pero le cuesta soltar, sabe que viene otra etapa y es por eso que entra en crisis. Crisis a modo de revisión interna.",
      "Podés soltar? Qué estás revisando?"
    ],
    image: lermite,
  },
  {
    id: 10,
    number: "X",
    name: "La Roue de Fortune",
    description: [
      "He aquí la carta nro diez.Es una rueda que cierra un ciclo o, que al menos, eso intenta. Porque al ser rueda, puede volver a comenzar. Pero se queda ahí en loop.",
      "Qué debo finalizar? Qué estoy repitiendo?"
    ],
    image: laRoueDeFortune,
  },
  {
    id: 11,
    number: "XI",
    name: "La Force",
    description: [
      "Nos adentramos en un nuevo camino, una nueva búsqueda. Comienza un camino mas profundo.",
      "La mujer está domando al león o el león a ella? La cabeza del animal, pareciese salir de su sexo. Esta imagen nos habla del deseo y del control. Por eso, dejamos la cabeza para conectarnos con nuestra impulsividad, con eso que nos nace.",
      "La pregunta es… Cuál es mi deseo? Estoy controlando? O me dejo controlar?"
    ],
    image: laForce,
  },
  {
    id: 12,
    number: "XII",
    name: "Le Pendu",
    description: [
      "Te detenés a observar, hay algo que te hizo frenar. Algo te hizo ruido pero no le encontrás la vuelta. Ahí es cuando te das vuelta vos y mirás todo de otra manera. Es el famoso  momento “aha”, en donde te das cuenta que las cosas que pensabas, que te habían dicho, te habían enseñado, etc; no son lo que pensabas. Es un nuevo pensar, un nuevo sentir.",
      "Se cuelga cómodo y tranquilo. Lo sostienen dos pilares, que ven podrían ser arboles. Y de ahí “pende” de un cordón. Arbol de familia y cordón umbilical te suenan? Claro, esto puede estar relacionado a cortar con el legado familiar, o con nuestros padres. Pero esto tb aplica para muchas otros momentos adolescentes. Tradiciones, jefes, tiempos, ideas, etc; todos ellos pueden tb romperse, para así transformarse.",
    ],
    image: lePendu,
  },
  {
    id: 13,
    number: "XIII",
    name: null,
    description: [
      "Es una muerte? Sí. Pero es una transformación y transmutación. Me gusta llamarle momento “Marie Kondo”. Porque es tiempo de hacer limpieza, de todo tipo: vínculos, trabajos, cosas, acciones, transiciones, ideas, tiempos.",
      "Como ven esta imagen refleja un cuerpo esquelético. Primero se deshace de ru ropaje, hasta quedar en huesos. Pero luego continúa con su hoz arando la tierra, preparando el terreno para la nueva siembra.",
      "Qué debe transformarse en mi vida? Que quiero sembrar? De qué me debo deshacer?"
    ],
    image: thirteen,
  },
  {
    id: 14,
    number: "XIIII",
    name: "Tenperance",
    description: [
      "Despues de una tormenta, llega la calma.La templanza se aparece en forma de ángel para alivianar la cosas, para equipararlas, para “templarlas”",
      "Esta es una señal, a modo de bendición."
    ],
    image: tenperance,
  },
  {
    id: 15,
    number: "XV",
    name: "Le Diable",
    description: [
      "Este ser alado, andrógino, con tetas, pene, y ojos por todas partes tiene a otros, cual prisioneros, dos a sus pies. En su mano cuenta con una antorcha. Y tb mira de frente, pero algo bizco.",
      "Como su nombre nos indica, es un ángel caído. Que busca la luz, el ascenso. Sabe que primero debe trabajar y ocuparse de su oscuridad.",
      "Esta carta asi como nos enfrenta con nuestros miedos y tentaciones; también nos muestra juegos de poder, abusos , excesos."
    ],
    image: leDiable,
  },
  {
    id: 16,
    number: "XVI",
    name: "La Maison Diev",
    description: [
      "La casa Dios, o La torre, muestra una torre coronada, que se abre en su techo y parece destapar algo, y de allí sale algo y explota. Los personajes parecen haber sido expulsados de la misma.",
      "Hay algo que se rompe, se destapa.Es un cambio incómodo, porque nuestra estructura se quiebra.Pero no podemos hacer nada.O nos resistimos y vuelve con fuerza: o lo aceptamos y fluimos.",
      "Se relaciona a cambios estructurales.Ya sea una mudanza, un viaje largo, una separación, la nueva llegada de un integrante, etc.Algo en nuestra vida necesita o está cambiando."
    ],
    image: laMaisonDieu,
  },
  {
    id: 17,
    number: "XVII",
    name: "L'Étoille",
    description:
      ["Esta mujer sentada a orillas de un rio, desnuda, volcando dos ánforas, es un símbolo de entrega. Encontró su lugar y su manera de brindarse al mundo. No esconde nada, su entrega es desinteresada y transparente.",
      "La estrella es esa persona que lo da todo, super generosa, que siempre piensa en los demás.Pero no es una fuente inagotable.Tiene que aprender a que eso que da, tb se lo de a sí misma.",
      ],
    image: lestoille,
  },
  {
    id: 18,
    number: "XVIII",
    name: "La Lune",
    description: [
      "Arquetipo de madre por excelencia, esta carta nos muestra dos animales que parecen ser perros/lobos, disputando algo a orillas de un lago, en donde se encuentra un cangrejo que trae una perla. En la tierra se ven dos torres de cada lado de los mamíferos. En el cielo, de noche, una luna sol. Brilla fuerte, e irradia su energía atrapante.",
      "Esta energía profunda nos hace ir a lo seguro, a casa. Tan reconfortante que no puedo salir, es una introspección a la que me es imposible salir, mi cabeza no para, mi imaginación tampoco. El afuera es amenazante.",
      "Por más cómodos que nos sintamos en este espacio, es necesario salir para conectar con la realidad y dejar de hacernos la cabeza."
    ],
    image: laLune,
  },
  {
    id: 19,
    number: "XVIIII",
    name: "Le Soleil",
    description: [
      "El encuentro con la luz es fuerte, cuesta acostumbrarse. ES adaptación y aceptación pura",
      "Acá vemos como hay dos personajes que aparentan ser iguales. Uno está parado en suelo firme y parece estar ayudando al otro, que se siente mas inseguro. El Sol viene a iluminar eso justamente. El poder aceptar esas dos partes de nosotros, la segura y plantada y la que conlleva miedos y debilidades. Esas dos partes hacen la unidad y nos hacen seres únicos e irrepetibles.",
      "Como arquetipo paterno, esta carta, invita a la acción, a salir, a construir."
    ],
    image: leSoleil,
  },
  {
    id: 20,
    number: "XXI",
    name: "Le Jugement",
    description: [
      "El llamado es claro! Esta trompeta suena a modo de resurrección. Es la bendición! Algo despierta en nosotros, esta alerta suena por algo.",
      "Qué debo despertar en mi ? Cuál es el llamado ?"
    ],
    image: leJugement,
  },
  {
    id: 21,
    number: "XXII",
    name: "Le Monde",
    description: [
      "Hemos concluído un ciclo importante. Es una realización. Somos completos, Todos nuestros centros están equilibrados.",
      "Vemos una mujer coronada con cuatro seres alrededor ( un ángel, un águila, un león y un toro). Estas son las cuatro energías: la emocional, la mental, la vital y la material. Así como una coronación de un proceso o de un premio, esto podría representar un encierro, el no poder ver su completitud. También podría ser que el huevo (proyecto) esté listo para salir y así comenzar un nuevo ciclo."
    ],
    image: leMonde,
  },
];

export default cardList;
